import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Gift } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [params] = useSearchParams();
  const nav = useNavigate();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const refFromUrl = (params.get("ref") || "").toUpperCase();
  useEffect(() => { if (refFromUrl) localStorage.setItem("pending_ref", refFromUrl); }, [refFromUrl]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Akun dibuat! Selesaikan pembayaran member untuk mengaktifkan akun.");
      nav("/member");
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-6 py-12 grain">
      <div className="w-full max-w-md bg-white rounded-3xl border border-stone-200 shadow-sm p-8">
        <div className="w-12 h-12 rounded-xl bg-emerald-600 flex items-center justify-center text-white font-display font-extrabold text-xl mb-5">K</div>
        <h1 className="font-display text-2xl font-bold text-stone-900">Daftar Akun</h1>
        <p className="text-sm text-stone-500 mt-1">Daftar wajib jadi member berbayar — akun aktif setelah pembayaran dikonfirmasi admin.</p>
        {refFromUrl && <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-xs text-amber-700 flex items-center gap-2" data-testid="reg-ref-banner"><Gift size={14} />Kode referral <b>{refFromUrl}</b> diterapkan saat daftar member: kamu dapat <b>diskon Rp10.000</b> (paket Rp50.000 cukup bayar Rp40.000).</div>}
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><label className="text-sm font-medium text-stone-600">Nama</label>
            <input data-testid="reg-name" value={form.name} onChange={set("name")} required className="mt-1.5 w-full border border-stone-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-emerald-400" placeholder="Nama lengkap" /></div>
          <div><label className="text-sm font-medium text-stone-600">Email</label>
            <input data-testid="reg-email" type="email" value={form.email} onChange={set("email")} required className="mt-1.5 w-full border border-stone-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-emerald-400" placeholder="email@contoh.com" /></div>
          <div><label className="text-sm font-medium text-stone-600">No. HP</label>
            <input data-testid="reg-phone" value={form.phone} onChange={set("phone")} className="mt-1.5 w-full border border-stone-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-emerald-400" placeholder="0812xxxxxxxx" /></div>
          <div><label className="text-sm font-medium text-stone-600">Password</label>
            <input data-testid="reg-password" type="password" value={form.password} onChange={set("password")} required className="mt-1.5 w-full border border-stone-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-emerald-400" placeholder="••••••••" /></div>
          <button data-testid="reg-submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 rounded-xl transition flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="animate-spin" size={18} />}Daftar
          </button>
        </form>
        <p className="text-sm text-stone-500 mt-5 text-center">Sudah punya akun? <Link to="/login" className="text-emerald-700 font-semibold">Masuk</Link></p>
      </div>
    </div>
  );
}
